export enum ValidateStoreEnum {
  LOAD = 'L',
  SUBMIT = 'S'
}
